import api from '../../config/api';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.superchargeme.com';

/**
 * Order-drafts API client (separate retail_order_drafts table — inert for all
 * calculations). Kept here under components/wholesale-orders rather than in the
 * shared services/ layer so the order-entry + list components can reuse it.
 */

// List a brand's open drafts (display fields only) — merged into the Orders list.
export const listOrderDrafts = async (brandId) => {
  const response = await api.get(`${API_BASE}/api/cogs/brands/${brandId}/retail-orders/drafts`);
  return response.data;
};

// Full draft incl. draft_payload (saved form state) for rehydration on reopen.
export const getOrderDraft = async (brandId, draftId) => {
  const response = await api.get(`${API_BASE}/api/cogs/brands/${brandId}/retail-orders/drafts/${draftId}`);
  return response.data;
};

// Create or update a draft. Pass draft_id to update an existing one (upsert).
// Body: { draft_id?, order_type, customer_name?, customer_id?, event_date?,
//         currency?, products_info?, draft_payload, origin? }. No field required.
export const saveOrderDraft = async (brandId, data) => {
  const response = await api.post(`${API_BASE}/api/cogs/brands/${brandId}/retail-orders/drafts`, data);
  return response.data;
};

// Discard a draft (tombstone). Does NOT touch any order or stock.
export const deleteOrderDraft = async (brandId, draftId) => {
  const response = await api.delete(`${API_BASE}/api/cogs/brands/${brandId}/retail-orders/drafts/${draftId}`);
  return response.data;
};

// Mark a retail order dispatched (goods left the WH) → status in_transit + dispatch_date.
// Stock deducts at dispatch (the later Ship step just records the shipped date).
export const dispatchRetailOrder = async (brandId, orderId, dispatchDate) => {
  const response = await api.post(
    `${API_BASE}/api/cogs/brands/${brandId}/retail-orders/${encodeURIComponent(orderId)}/dispatch`,
    { dispatch_date: dispatchDate }
  );
  return response.data;
};

// Undo a dispatch (in_transit → pending, clears dispatch_date; computed stock re-credits).
export const reverseDispatchRetailOrder = async (brandId, orderId) => {
  const response = await api.post(
    `${API_BASE}/api/cogs/brands/${brandId}/retail-orders/${encodeURIComponent(orderId)}/reverse-dispatch`,
    {}
  );
  return response.data;
};

// Correct/clear fulfilment date columns (no stock movement). Pass any subset of
// { dispatch_date, shipped_date, qb_invoice_id, qb_invoice_date, sync_dispatch_status }.
export const updateFulfilmentDates = async (brandId, orderId, body) => {
  const response = await api.post(
    `${API_BASE}/api/cogs/brands/${brandId}/retail-orders/${encodeURIComponent(orderId)}/update-fulfilment-dates`,
    body
  );
  return response.data;
};
